import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import Datatable from '../../modules/datatable/datatable';
import RightPanel from '../shared/rightPanel';
import RightPanelSelector from '../shared/rightPanelSelector';
import ModalSelector from '../shared/modalSelector';
import { PanelsType, ModalsType } from '../../modules/dialogs/model';
import * as Orders from '../../modules/orders';
import DataTableSummary from '../shared/datatable/summary';
import Scrim from '../shared/scrim';

interface StateProps {
  ordersState: Orders.State;
  activeDialog: PanelsType;
  activeModal: ModalsType;
}

type Props = StateProps;

const OrderContent: React.FC<Props> = (props) => {
  useLifecycle('OrdersContent');

  useEffect(() => {
    props.ordersState.pagesToLoad.forEach((pageIdx) => {
      Orders.searchPage(pageIdx);
    });
  }, [props.ordersState.pagesToLoad]);

  return (
    <div className="layout__content__main" style={{ height: '100%' }}>
      <RightPanel
        isOpened={!!props.activeDialog}
        content={<RightPanelSelector activeDialog={props.activeDialog} />}
      >
        <DataTableSummary
          dtState={props.ordersState}
          clearSelection={Orders.clearSelection}
          msgMain={Orders.keyTotalOrders}
        />
        <Scrim
          isActive={props.ordersState.table.isLoading}
          fullHeight
          hideSpinner
        >
          <div className="layout__content__table_wrapper">
            <div className="datatable__layout">
              <Datatable
                rows={props.ordersState.table.content}
                getPK={props.ordersState.selection.getPK}
                isLoading={false}
                columns={props.ordersState.table.columns}
                isSelectable
                allSelected={props.ordersState.selection.isAllSelected}
                onToggleItemSelection={Orders.updateTableItemSelection}
                isItemSelected={Orders.isTableItemSelected}
                onToggleAllSelected={Orders.updateTableSelectAll}
                pagination={props.ordersState.table.pagination}
                onPageChange={Orders.changeTablePage}
                onPageSizeChange={Orders.changeTableSizePage}
                sortCriteria={props.ordersState.sort}
                onSortCriteriaChanged={Orders.changeTableSorting}
              />
            </div>
          </div>
        </Scrim>
      </RightPanel>
      <ModalSelector activeModal={props.activeModal} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  ordersState: state.ordersState,
  activeDialog: state.dialogState.activeDialog,
  activeModal: state.dialogState.activeModal,
});

export default connect(mapStateToProps)(OrderContent);
